export default __webpack_public_path__ + "static/summit_stars_4_4-3ec73d0f857fef30812c4efb35a1aecc.svg";